"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FullCreditPriceModal = require("./FullCreditPriceModal");
Object.keys(_FullCreditPriceModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FullCreditPriceModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FullCreditPriceModal[key];
    }
  });
});